import type { ColumnMetadata, LookupDataItem } from '../grid/types';
import { resolveObserverFieldName } from './currencyRateOptions';

export const INVOICE_BANK_BY_CURRENCY_JS_METHOD =
  'ZAssets.Fields.MethodSetDefaultInvoiceBankByCurrency';

export type InvoiceBankJsMethodOptions = {
  observerIdElement: string;
  companyIdElement?: string;
  companyEditorType?: 'dxDropDownBox' | 'dxSelectBox';
};

const decodeLegacyJson = (value: string): string => value.replace(/&quot;|&#34;|&#x22;/gi, '"');

export const parseInvoiceBankJsMethodOptions = (
  rawOptions: string | null | undefined
): InvoiceBankJsMethodOptions | null => {
  if (!rawOptions) {
    return null;
  }

  try {
    const options = JSON.parse(decodeLegacyJson(rawOptions)) as Partial<InvoiceBankJsMethodOptions>;
    if (!options.observerIdElement?.trim()) {
      return null;
    }

    const companyIdElement = options.companyIdElement?.trim();
    const companyEditorType =
      options.companyEditorType === 'dxDropDownBox' || options.companyEditorType === 'dxSelectBox'
        ? options.companyEditorType
        : undefined;
    return companyIdElement
      ? { observerIdElement: options.observerIdElement.trim(), companyIdElement, companyEditorType }
      : { observerIdElement: options.observerIdElement.trim() };
  } catch {
    return null;
  }
};

export const resolveInvoiceCurrencyFieldName = (
  fields: ColumnMetadata[],
  observerIdElement: string
): string | null => resolveObserverFieldName(fields, observerIdElement);

export const resolveInvoiceCompanyFieldName = (
  fields: ColumnMetadata[],
  companyIdElement: string | undefined
): string | null => (companyIdElement ? resolveObserverFieldName(fields, companyIdElement) : null);

const isDefaultBank = (item: LookupDataItem): boolean => {
  const defaultField = item.Fields?.find(
    (field) => field.Name?.toLowerCase() === 'isdefaultcurrency'
  );
  const topLevelValue = (item as LookupDataItem & { IsDefaultCurrency?: unknown })
    .IsDefaultCurrency;
  const value = String(topLevelValue ?? defaultField?.StringValue ?? '')
    .trim()
    .toLowerCase();
  return value === 'true' || value === '1';
};

export const resolveDefaultInvoiceBankId = (items: LookupDataItem[] | undefined): string | null => {
  if (!items?.length) {
    return null;
  }

  const defaultBank = items.find(isDefaultBank);
  if (defaultBank) {
    return String(defaultBank.Id);
  }

  return items.length === 1 ? String(items[0].Id) : null;
};
